import React from 'react';
import InsightSurface from '../shared/InsightSurface';

/**
 * VerdictPanel — the loudest text on the MY WORK page (Epic 4 · S4.1).
 *
 * The verdict is the synthesis — Part E.1: it is the one block that is the
 * exception to the "return null, leave the chart" rule. It renders verbatim
 * (never edited, clamped, or fixed-height) on the calm gray glass surface, at
 * `.gi-verdict` scale (the --type-verdict token — roughly double body), so it is
 * unmistakably bigger than the page title beneath it.
 *
 * Hide rule: the verdict is `null`/empty ONLY when `status === 'no_data'`. An
 * empty park (Verde) still gets a real verdict, so this component renders
 * nothing only when the verdict string itself is absent — the shell decides
 * that (it passes `verdict` only when present).
 *
 * No click, no dismiss: the verdict "is the synthesis" (Part C). It delegates
 * entirely to `InsightSurface` (`variant="verdict"` adds the extra padding +
 * the `.gi-verdict` paragraph; `tone="gray"` is the calm blue-indigo wash, not
 * an error colour).
 */
const VerdictPanel = ({ verdict }) => {
  if (!verdict) return null;
  return (
    <InsightSurface tone="gray" variant="verdict">
      {verdict}
    </InsightSurface>
  );
};

export default VerdictPanel;
